import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const isAuthInitialized = useSelector((state) => state.auth.isInitialized);
  const location = useLocation();

  if (!isAuthInitialized) return null;

  if (!isAuthenticated && location.pathname !== "/login" && location.pathname !== "/") {
    return <Navigate to="/" />;
  }

  return children;
};

export default ProtectedRoute;